/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICittaStoreLocationsNewViewProps } from './citta-store-locations-new';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

export default (props: ICittaStoreLocationsNewViewProps) => {
    const { CittaStores, CittaStoreLocations,StoreLocationsNode } = props;
    return (
        <Module {...CittaStores}>
            <Node {...CittaStoreLocations} className='row'>
                {StoreLocationsNode}
            </Node>
        </Module>
    );
};
